module.exports = __webpack_public_path__ + "img/Triss.ed826ec.png";